<div class="min-h-screen flex flex-col">
	<main class="flex-1 min-h-0">
		<router-outlet></router-outlet>
	</main>
	<app-footer class="mt-auto mt-2 shrink-0"></app-footer>
</div>

<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>